import { render, staticRenderFns } from "./global-pagination-template.vue?vue&type=template&id=49a6d0ed&scoped=true"
import script from "./global-pagination-template.vue?vue&type=script&lang=js"
export * from "./global-pagination-template.vue?vue&type=script&lang=js"
import style0 from "./global-pagination-template.vue?vue&type=style&index=0&id=49a6d0ed&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a6d0ed",
  null
  
)

export default component.exports